import { EmsgInfo } from '../../internal/EmsgInfo';
import { PlayerTimedEventResponse } from './CommandResponses';
import { CryptoJS } from '@quickplay/foundation';

/**
 * Converts the timed metadata playload from WebMAF to be inline with `Player` spec.
 * Converts the base64 payload into a `Uint8Array` so downstreams components can use a
 * consistent API
 *
 * @param event the timedmetadata payload
 */
export const covertToEmsgInfo = (event: PlayerTimedEventResponse): EmsgInfo => {
  const stringToBytes = (string: string): Uint8Array => {
    const length = string.length;
    const array = new Uint8Array(new ArrayBuffer(length));
    for (let i = 0; i < length; i++) {
      array[i] = string.charCodeAt(i);
    }
    return array;
  };

  if (!(event && event.details)) {
    return {};
  }

  const details = event.details;

  return {
    schemeIdUri: details.scheme,
    value: details.value,
    get startTime(): number {
      try {
        return parseInt(event.timestamp) / 1000;
      } catch {
        return 0;
      }
    },
    endTime: undefined,
    timescale: details.timescale,
    presentationTimeDelta: undefined,
    eventDuration: details.eventDuration,
    id: details.id,
    get messageData(): Uint8Array {
      const words = CryptoJS.enc.Base64.parse(event.data);
      return stringToBytes(words.toString(CryptoJS.enc.Utf8));
    },
  };
};
